const storageKey = (eventId, portal = "company") =>
  `${portal}EventApplicantsState:${eventId}`;

export const saveEventApplicantsListState = (eventId, state, portal = "company") => {
  if (!eventId || !state) return;
  try {
    sessionStorage.setItem(storageKey(eventId, portal), JSON.stringify(state));
  } catch {
    // sessionStorage may be unavailable in private browsing.
  }
};

export const consumeEventApplicantsListState = (eventId, portal = "company") => {
  if (!eventId) return null;
  try {
    const raw = sessionStorage.getItem(storageKey(eventId, portal));
    if (!raw) return null;
    sessionStorage.removeItem(storageKey(eventId, portal));
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const peekEventApplicantsListState = (eventId, portal = "company") => {
  if (!eventId) return null;
  try {
    const raw = sessionStorage.getItem(storageKey(eventId, portal));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const buildEventApplicantsListSnapshot = ({
  activeStatus,
  search,
  filters,
  page,
  pageSize,
  scrollY,
}) => ({
  activeStatus,
  search,
  filters,
  page,
  pageSize,
  scrollY: scrollY ?? (typeof window !== "undefined" ? window.scrollY : 0),
});
